import React, { useState, useEffect } from "react";
import { css } from "emotion";
import { stepContent, header, singleInput } from "./../style";
import InputForm from "../../../../../shared/atoms/InputForm";

import { patternOnlyNumbers } from "../../../../../shared/create-offer/utils/masks";

import SeeMore from "../../shared/SeeMore";
import { useNewOfferMobile } from "../../context";
import { useNewOffer } from "../../../../context/new-offer";

// Debounce function
let timerId;
let fnWaiting;
const debounced = (fn, delay = 250) => {
	if (timerId) clearTimeout(timerId);
	if (!fn && fnWaiting) fnWaiting();
	fnWaiting = fn;
	if (!fn) return;
	timerId = setTimeout(fn, delay);
};

const PasswordRecovery = ({ onChangeLoyalty }) => {
	const { currentProgram: fidelityProgram, loyaltyData } = useNewOffer();
	// Máximo de caracteres para senha da Multiplus
	const maxLengthPassMultiplus = 5;

	const { setStepError } = useNewOfferMobile();

	const [state, setState] = useState({
		pwAwardSecondary: loyaltyData.data.pwAwardSecondary || "",
		forgotPassword: false,
		hasError: false
	});

	const [debouncing, setDebouncing] = useState(false);

	useEffect(() => {
		const pwAwardSecondary = loyaltyData.data.pwAwardSecondary || "";
		const hasError =
			pwAwardSecondary !== undefined && pwAwardSecondary.length !== maxLengthPassMultiplus;
		setState({
			...state,
			pwAwardSecondary,
			hasError: !debouncing && hasError
		});

		setStepError(!pwAwardSecondary || hasError || debouncing);
	}, [loyaltyData.data, debouncing]);

	const onChange = ev => {
		let pwAwardSecondary = ev.target.value.match(patternOnlyNumbers)
			? ev.target.value.match(patternOnlyNumbers).toString()
			: "";
		setDebouncing(true);
		setState({
			...state,
			pwAwardSecondary
		});
		debounced(() => setDebouncing(false), 1000);
		onChangeLoyalty({ pwAwardSecondary });
	};

	return (
		<div
			className={css`
				${stepContent};
			`}
		>
			<strong
				className={css`
					${header};
				`}
			>
				Dados da {fidelityProgram.fidelityName}
			</strong>
			<div
				className={css`
					${singleInput};
				`}
			>
				<InputForm
					name="pwAwardSecondary"
					id="pwAwardSecondary"
					type="password"
					autocomplete="off"
					value={state.pwAwardSecondary}
					maxLength={5}
					onChange={onChange}
					onBlur={() => debounced(null)}
					placeholder=""
					label="Senha de resgate"
					errorMessage={`Senha inválida. Atenção! Esta senha deve ter ${maxLengthPassMultiplus} números.`}
					hasError={state.hasError}
					helperText={
						<div className="box-fidelity-program-details--forgot-password">
							<a
								href="https://www.pontosmultiplus.com.br/portal/pages/MeusDadosSenhas.html"
								target="_blank"
								data-action="forgot-password-secondary"
							>
								Esqueci minha senha
							</a>
						</div>
					}
					data-action="login-offer-rescue-password"
				/>
			</div>

			<SeeMore>
				<strong>Senha de resgate do Latam Pass</strong>

				<p>
				Atenção! A senha de resgate é diferente da senha de acesso à sua conta Latam Pass. Ela 
				tem 5 números e pode ser alterada ou solicitada no site do programa
				, na área <strong>Minha Conta</strong>, clicando em <strong>Senhas</strong>.	
				</p>
			</SeeMore>
		</div>
	);
};

export default PasswordRecovery;
